module.exports = __webpack_public_path__ + "img/Preguntas frecuentes 768px-1.2e967a7a.png";